import { decodeHTMLStrict } from 'entities';

const BLOCK_TAG_PATTERN = /<\/\s*(p|div|li|ul|ol|h[1-6])\s*>/gi;
const LINE_BREAK_PATTERN = /<\s*br\s*\/?>/gi;
const UNSAFE_BLOCK_PATTERN = /<\s*(script|style)[^>]*>[\s\S]*?<\/\s*\1\s*>/gi;
const TAG_PATTERN = /<[^>]*>/g;
const WHITESPACE_PATTERN = /\s+/g;

export const sanitizeLegalDisclaimer = (value: string | null | undefined): Array<string> =>
  decodeHTMLStrict(
    (value ?? '')
      .replace(UNSAFE_BLOCK_PATTERN, '')
      .replace(LINE_BREAK_PATTERN, '\n')
      .replace(BLOCK_TAG_PATTERN, '\n')
      .replace(TAG_PATTERN, ''),
  )
    .split('\n')
    .map((line) => line.replace(WHITESPACE_PATTERN, ' ').trim())
    .filter(Boolean);
